import $axios from './api';

export const getChatList = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/chat/list', payload);
	return data;
};

export const getMessages = async (payload = {}) => {
	const { data } = await $axios.post('/v1/author/chat/messages', payload);
	return data;
};

export const sendMessage = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/send', payload);
	return data;
};

export const markRead = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/markRead', payload);
	return data;
};

export const blockChat = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/block', payload);
	return data;
};

export const unblockChat = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/unblock', payload);
	return data;
};

export const hideChat = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/hide', payload);
	return data;
};

export const unhideChat = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/unhide', payload);
	return data;
};

export const reportMessage = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/report', payload);
	return data;
};

export const hideMessage = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/message/hide', payload);
	return data;
};

export const unhideMessage = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/message/unhide', payload);
	return data;
};

export const unreportMessage = async (payload) => {
	const { data } = await $axios.post('/v1/author/chat/unreport', payload);
	return data;
};
